export const iconFontAwesomeMedicalHealthBanSmoking = (
	<i className="fa-solid fa-ban-smoking"></i>
);
